import * as router from "@client/router";
import {MacrosWizard, RegisterWizard} from "@client/scenes/register/Wizard";
import React from "react";

export const Registration = router.Registration.withHooks((props) => ({
    demo: props.resolved.register.demo,
}))
    .withIndex((props) => <RegisterWizard demoAllowed={props.demo} />)
    .withActions(() => [])
    .withOptions(() => ({title: "Sign up", scene: {kind: "EMPTY"}}));

export const Macros = router.Macros.withHooks((props) => ({
    profile: props.profile,
    demo: props.resolved.macros.demo,
}))
    .withIndex((props) => (
        <MacrosWizard profile={props.profile} demoAllowed={props.demo} />
    ))
    .withActions(() => [])
    .withOptions(() => ({title: "Your macros", scene: {kind: "EMPTY"}}));
